@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.save-filterview-modal {
  width: 400px;
  min-height: 220px;
}

.modal-body {
  padding: 15px;
  overflow: auto;
}

.modal-content {
  display: flex;
  flex-direction: column;
}

.error-wrapper {
  display: flex;
  flex-direction: row;
  padding: 10px;
  background: @save-filterview-modal--wrapper--error--background-color;
}

.error-details {
  font-size: 13px;
  padding-left: 10px;
  margin: auto;
}

.error {
  display: flex;
  flex-direction: row;
  border-right: 1px solid @save-filterview-modal--error--border-color;
  align-items: center;

  svg {
    height: 35px;
    width: 35px;
    padding: 8px;
    fill: @save-filterview-modal--error--fill-color;
  }

  .error-message {
    flex: 1;
    font-size: 16px;
    color: @save-filterview-modal--error--text-color;
    padding-right: 10px;
  }
}

.dropdown-button,
.dropdown-button button {
  width: 100%;
  height: 42px;
}

.modal-footer {
  > button {
    margin-left: 10px;
  }
}
